import React, { Component } from "react";
import { connect } from "react-redux";
import Graphics from "components/pipette/components/controls/ControlGraphics";
import { findIndex, isEqual } from "lodash"
import {Decimal} from 'decimal.js';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../../toast/Toast";

import {WhiteHamburgerIcon} from '@learningblocks/storybook-components/lib/Icons';

import {
  pushInteractions,
  // incVol,
  // decVol,
  setPipetteSolution,
  setTipAttached,
  setTipUsed,
  setAnimatingOut,
  setPlungerPosition,
  setCurrentPlungerPos,
  setPipetteControlVisibility,
  depositBlotPaper,
  trashFull,
  incSolution,
  decSolution,
  setControlVisibility,
  setModal,
  showModal,
  setMoveMenu,
  showMoveMenu,
  setHeldObject,
  setHeld,
  setGelLane,
  makeGelImgConfig,
  // setVol,
  setSolutionMixed,

  toggleShowVolumeModal,
  toggleGelboxPipetteModal
} from "../../../../actions";

// Icons
import IconPointer from "components/icons/pointer-solid";

// Styles
import colors from "styles/_exports.module.scss";

import { withTranslation } from 'react-i18next'

class Controls extends Component {
  constructor(props) {
    super(props);

    this.state = {
      teleportVisible: false,
      runMethod: false
    };

    const interactions = (heldObj, target) => {
      //Don't run if this pipette not the held object
      if(heldObj.type !== "Pipette" || heldObj.id !== this.props.id){
        return null;
      }
      if (target === undefined || target === null) {
        return null;
      }

      //All GelBox interactions
      if (target.type === "GelBox") {
        //Get the targeted TipBox
        const gelsID = target.id
        const targetGelBox = this.props.interactionProps.gelBoxes[gelsID - 1]

        if(!this.props.tipAttached){

          //Alert - pipette already has a tip attached
          this.makeToast("WARNING", "The pipette needs a tip attached first.", "You need to add a tip to the micropipette.")

        } else if(targetGelBox.open) {

          //Tip Box open - attach tip
          if (targetGelBox.containsGel) {
            //There is a gel in the box, and the pipette has a tip attached
            this.showGelModal()

          } else {
            //Alert - pipette already has a tip attached
            this.makeToast("WARNING", "The gel box has no gel inside.", "There needs to be a gel before you can add a solution.")
          }
        } else if(!targetGelBox.open){

          this.makeToast("WARNING", "You need to open the lid of the gel box fist.", "Gel box closed!")
        } else {
          return null;
        }
      }

      //All TipBox interactions
      if (target.type === "TipBox") {
        //Get the targeted TipBox
        const tipsID = target.id;
        const tipsType = target.tipType;
        const targetTipBox = this.props.interactionProps.tipBoxes[tipsID - 1];
        const shareTips = ["P20", "P100", "P200"];
        if (
          (shareTips.includes(this.props.type) &&
            shareTips.includes(tipsType)) ||
          tipsType === this.props.type
        ) {
          if (targetTipBox.open) {
            //Tip Box open - attach tip
            if (!this.props.tipAttached) {
              //No tip attached - can attach new tip
              this.props.setTipUsed({
                id: this.props.id,
                used: false
              });
              this.props.setPipetteSolution({
                id: this.props.id,
                solution: null,
                solutionAlias: null
              });
              this.props.setTipAttached({
                id: this.props.id,
                attached: true
              });
            } else {
              //Alert - pipette already has a tip attached
              this.makeToast(
                "WARNING",
                "This pipette already has a tip attached.",
                "Tip already attached!"
              );
            }
          } else {
            //Alert - open tip box
            this.makeToast(
              "WARNING",
              "You must open the tip box first.",
              "Tip box is closed! "
            );
          }
        } else {
          //Alert - wrong type of tipbox for this pipette
          this.makeToast(
            "WARNING",
            "These tips do not fit the " + this.props.type + " pipette!",
            "Wrong tip box!"
          );
        }
      } else {
        return null;
      }
    };

    Object.defineProperty(interactions, 'name', {value: ('pipette_controls_interactions_'+this.props.id), configurable: true});
    this.props.pushInteractions([interactions]);
  }

  showGelModal = () => {
      // this.props.setModal({
      //     type: 'GEL_PIPETTE',
      //     size: 'lg',
      //     pipetteId: this.props.id,
      //     gelId: 1,
      //     gelBoxId: 1,
      //   });
      // this.props.showModal({display: true});
      this.props.toggleGelboxPipetteModal({
        id: 1,
        showGelPipetteModal: true,
        pipetteId: this.props.id,
        gelId: 1,
        gelBoxId: 1
      })
  }

  makeToast = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
  };

  //Extracts liquid into pipette
  extract = (factor) => {

    if(typeof factor == 'undefined'){
      factor = 1;
    }

    const lastDrop = this.props.interactionProps.lastDrop;

    if(this.props.prevSolution !== null){	
      //If target of last drop was a solution	
      if (lastDrop.lastTarget.type === "Solution") {	
        const solutionID = lastDrop.lastTarget.id;	
        const solutionObj = this.props.interactionProps.solutions[solutionID - 1];	
        if(isEqual(Object.keys(this.props.prevSolution), Object.keys(solutionObj.solutions))){	
          this.props.setSolutionMixed({	
            id: solutionID,	
            mixed: true,	
          });	
        }	
      }
    }

    if (lastDrop.lastHeld === null || lastDrop.lastTarget === null) {
      this.makeToast(
        "WARNING",
        "Please place the pipette over a valid extraction target.",
        "No extraction target found!"
      );
      return null;
    }

    if (
      lastDrop.lastHeld.id !== this.props.id ||
      lastDrop.lastHeld.type !== "Pipette"
    ) {
      this.makeToast(
        "WARNING",
        "Please place the pipette over a valid extraction target.",
        "No extraction target found!"
      );
      return null;
    }

    //Ending function if no target
    if (lastDrop.lastTarget === undefined || lastDrop.lastTarget === null) {
      this.makeToast(
        "WARNING",
        "Please place the pipette over a valid extraction target.",
        "No extraction target found!"
      );
      return null;
    }
    //If target of last drop was a solution
    if (lastDrop.lastTarget.type === "Solution") {
      const solutionID = lastDrop.lastTarget.id;
      const solutionObj = this.props.interactionProps.solutions[solutionID - 1];

      if(this.props.solution === null){
        if (this.props.tipAttached) {
          //Only continue if tip attached - else warn
          if (solutionObj.open) {
            //Open - extract solution to pipette
            if (
              !this.props.tipUsed ||
              isEqual(
                Object.keys(this.props.prevSolution),
                Object.keys(solutionObj.solutions)
              )
            ) {
              //Only extract if tip not used
              let volume = null;
              let solution = null;
            
              if (solutionObj.volume >= this.props.volume) {
                // Only use the pipette volume if its greater
                // than the available solution volume
                volume = this.props.volume;
              } else {
                this.makeToast(
                  "WARNING",
                  "You have extracted air with your solution.",
                  "Air extracted!"
                );
                // Otherwise use the solution volume
                volume = solutionObj.volume;
              }

              // Create a new solution object and populate it
              // with all the solutions in the tube
              if (solutionObj.volume > 0) {
                solution = {};

                for (const solute in solutionObj.solutions) {
                  solution[solute] =
                    new Decimal(solutionObj.solutions[solute]).dividedBy(new Decimal(solutionObj.volume).dividedBy(new Decimal(volume))).toNumber();
                }
              }

              this.props.setPipetteSolution({
                id: this.props.id,
                solution: solution,
                fragments: solutionObj.fragments,
                solutionAlias: solutionObj.type
              });
              this.props.setTipUsed({
                id: this.props.id,
                used: true
              });
              this.props.decSolution({
                id: solutionID,
                type: solutionObj.type,
                amount: volume
              });
            } else {
              this.makeToast(
                "WARNING",
                "Please put this tip in trash and attach a new tip.",
                "Tip already used!"
              );
            }
          } else {
            this.makeToast(
              "WARNING",
              "Please open the solution before attempting to extract.",
              "Solution is closed!"
            );
          }
        } else {
          this.makeToast(
            "WARNING",
            "Please attach a tip before attempting to extract the solution",
            "No tip attached!"
          );
        }
      }
    }
  };

  //Deposits liquid from pipette
  deposit = () => {
    const lastDrop = this.props.interactionProps.lastDrop;

    if (lastDrop.lastHeld === null || lastDrop.lastTarget === null) {
      this.makeToast(
        "WARNING",
        "Please place the pipette over a valid deposit target.",
        "No deposit target found!"
      );
      return null;
    }

    if (
      lastDrop.lastHeld.id !== this.props.id ||
      lastDrop.lastHeld.type !== "Pipette"
    ) {
      this.makeToast(
        "WARNING",
        "Please place the pipette over a valid deposit target.",
        "No deposit target found!"
      );
      return null;
    }

    //Ending function if no valid target
    if (lastDrop.lastTarget === undefined || lastDrop.lastTarget === null) {
      this.makeToast(
        "WARNING",
        "Please place the pipette over a valid deposit target.",
        "No deposit target found!"
      );
      return null;
    }

    //Only try deposit if tip attached
    if (this.props.tipAttached) {
      //If target is valid deposit target
      if (lastDrop.lastTarget.type === "BlottingPaper") {
        const blotId = lastDrop.lastTarget.id;
        const depObj = this.props.interactionProps.blotPapers[blotId - 1];
        const depId = lastDrop.lastTarget.subId;

        //if deposit target hasn't already been used
        if (!depObj.used) {
          //If pipette isn't empty
          if (this.props.solution !== null) {
            // Create a new solution object and populate it
            // with all the solutions in the pipette
            const solution = {};
            let totalVolume = 0;
            for (const solute in this.props.solution) {
              solution[solute] = this.props.solution[solute];
              totalVolume += this.props.solution[solute];
            }

            //Run deposit with following data
            this.props.depositBlotPaper({
              id: blotId,
              solution: solution,
              solutionAlias: this.props.solutionAlias,
              volume: totalVolume,
              index: depId
            });
            this.props.setPipetteSolution({
              id: this.props.id,
              solution: null,
              solutionAlias: null
            });
          } else {
            this.makeToast(
              "WARNING",
              "Please extract a solution before depositing",
              "Tip is empty!"
            );
          }
        } else {
          this.makeToast(
            "WARNING",
            "Please try depositing in a different receptacle.",
            "Deposit already used!"
          );
        }
      } else if (lastDrop.lastTarget.type === "Gel") {

        const gelId = lastDrop.lastTarget.id;
        // const depObj = this.props.interactionProps.gels[gelId - 1];
        const lane = lastDrop.lastTarget.lane;
        const well = lastDrop.lastTarget.well;

        const solution = {};
        let totalVolume = 0;
        for (const solute2 in this.props.solution) {
          solution[solute2] = this.props.solution[solute2];
          totalVolume += this.props.solution[solute2];
        }

        if(totalVolume > 0){
          if(typeof lane !== "undefined" && lane > 0){
            if(typeof well !== "undefined" && well > 0){

                //HERE: All actions to reducers to set final outcomes
                this.props.setGelLane({
                  id: gelId,
                  laneNumber: lane,
                  laneData: {
                    volume: totalVolume,
                    solutions: solution,
                    solutionAlias: this.props.solutionAlias,
                    fragments: this.props.fragments,
                    particulate: this.props.interactionProps.solutions[
                      findIndex(this.props.interactionProps.solutions, {
                        type: this.props.solutionAlias
                      })
                    ].particulate,
                    empty: false
                  }
                });
                //Set pipette to empty
                // this.props.setVol({
                //   id: this.props.id,
                //   volume: 0
                // });
                this.props.setPipetteSolution({
                  id: this.props.id,
                  solution: null,
                  fragments: null,
                  solutionAlias: null
                });
                //Update image for gel if new lanes full
                this.props.makeGelImgConfig({
                  id: gelId
                });

            } else {
              this.makeToast(
                "WARNING",
                "Please place the pipette tip in the well before depositing.",
                "Not inside a well!"
              );
            }
          } else {
            this.makeToast(
              "WARNING",
              "Please place the pipette in a lane before depositing.",
              "No lane selected!"
            );
          }
        } else {
          this.makeToast(
            "WARNING",
            "Please place solution in the pipette tip before depositing.",
            "No solution in tip!"
          );
        }
      } else if (lastDrop.lastTarget.type === "Solution") {
        //Need id of target solution, type of deposit, amount of deposit
        this.props.incSolution({
          id: lastDrop.lastTarget.id,
          solutions: [this.props.solution],
          fragments: this.props.fragments
        })

        //Also delete solution in pipette
        this.props.setPipetteSolution({
          id: this.props.id,
          solution: null,
          solutionAlias: null
        });
      }
    } else {
      this.makeToast(
        "WARNING",
        "Please attach a tip before attempting to deposit.",
        "No tip attached!"
      );
    }
  };

  updatePlunger = elem => {

    function getTransform(elem) {
      const matrix = getComputedStyle(elem, null).transform;

      const regex = /-?\d*\.{0,1}\d+/g;
      const values = matrix.match(regex);

      let translateX = '';
      let translateY = '';

      if (values != null) {
        translateX = values[4];
        translateY = values[5];
      }

      return {
        'translateX': translateX,
        'translateY': translateY
      };
    }
    // We need to convert the px back to a percentage
    const matrix = getTransform(elem);
    const translateY = (matrix.translateY / elem.offsetHeight) * 100;
    let position = "";

    // Depending on the position percentage update the state
    if (translateY < 30) {
      position = "At Rest";
    } else if (30 <= translateY && translateY < 41) {
      position = "1st Stop";
    } else if (41 <= translateY) {
      position = "2nd Stop";
    }

    // If the new state does not equal the old state
    if (position !== this.props.plungerPosition && position !== "") {

      // Save the state
      this.props.setPlungerPosition({
        id: this.props.id,
        plungerPosition: position
      });

      if(this.props.interactionProps.lastDrop.lastTarget.type === 'Gel'){

        // Trigger the extract / deposit if the plunger
        // is being pushed down
        if (!this.props.animatingOut) {
          if (position === "1st Stop") {
            this.deposit();
          } else if(position === "2nd Stop"){
            this.makeToast(
              "WARNING",
              "Pressing the plunger down to the second stop may displace your sample from the well.",
              "Pushed to second stop!"
            );
          }
        }

      } else {

        // Trigger the extract / deposit if the plunger
        // is being pushed down
        if(!this.state.runMethod){
          if (!this.props.animatingOut) {
            console.log(position)
            if (position === "2nd Stop") {
              this.deposit();
              this.setState({
                runMethod: true
              })
            }
          } else {
            if (position === "1st Stop" && translateY > 39) {
              this.extract(2);
              this.setState({
                runMethod: true
              })
            }
            if (position === "At Rest" && translateY >= 28 && translateY < 41) {
              this.extract();
              this.setState({
                runMethod: true
              })
            }
          }
        }
        if(this.props.animatingOut && position === "At Rest"){
          this.setState({
            runMethod: false
          })
        }
      }
    }
  };

  shiftPlunger = e => {
    if (e.repeat) {
      return;
    } else {
      // This merely triggers the animation of the plunger
      // We need to determine the plungers current plunger
      // position before we animate it (as we don't)
      // always run the full animation sequence from 0

      const elem = document.getElementsByClassName(
        this.props.type + "-plunger"
      )[0];
      function getTransform(elem) {
        const matrix = getComputedStyle(elem, null).transform;

        const regex = /-?\d*\.{0,1}\d+/g;
        const values = matrix.match(regex);

        let translateX = '';
        let translateY = '';

        if (values != null) {
          translateX = values[4];
          translateY = values[5];
        }

        return {
          'translateX': translateX,
          'translateY': translateY
        };
      }

      if(elem !== null && typeof elem !== 'undefined'){
        // We need to convert the px back to a percentage
        const matrix = getTransform(elem);

        // We need to convert the px back to a percentage
        const translateY = (matrix.translateY / elem.offsetHeight) * 100;

        // Update the state values to trigger the animation
        this.props.setAnimatingOut({
          id: this.props.id,
          animatingOut:
            e.type === "mouseup" ||
            e.type === "keyup" ||
            e.type === "mouseout" ||
            e.type === "dragstart" ||
            e.type === "blur"
        });
        this.props.setCurrentPlungerPos({
          id: this.props.id,
          currentPlungerPos: translateY
        });

        // Update the plunger
        const interval = setInterval(this.updatePlunger, 1000 / 64, elem);
        setTimeout(clearInterval, 1200, interval);
      }
    }
  };

  showVolumeModal = () => {
    // this.props.setModal({
    //   type: "PIPETTE_VOLUME",
    //   size: "lg",
    //   connect: this.props.id
    // });
    // this.props.showModal({ display: true });

    this.props.toggleShowVolumeModal({ data: true, id: this.props.id })
  };

  showMoveMenu = () => {
    this.props.setMoveMenu({
      component: "micropipette",
      type: this.props.type,
      connect: this.props.id
    });
    this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
  };

  ejectTip = () => {
    if (
      this.props.interactionProps.lastDrop.lastTarget === null ||
      this.props.interactionProps.lastDrop.lastTarget === undefined ||
      this.props.interactionProps.lastDrop.lastHeld === null ||
      this.props.interactionProps.lastDrop.lastHeld === undefined
    ) {
      return null;
    }
    //Only if this pipette over Trash
    if (
      this.props.interactionProps.lastDrop.lastHeld.id === this.props.id &&
      this.props.interactionProps.lastDrop.lastTarget.type === "Trash"
    ) {
      //Set trash to full
      if (this.props.tipAttached) {
        this.props.trashFull(true);
      }
      //Clear tip data from pipette
      this.props.setTipAttached({
        id: this.props.id,
        attached: false
      });
      this.props.setTipUsed({
        id: this.props.id,
        used: false
      });
      this.props.setPipetteSolution({
        id: this.props.id,
        solution: null,
        solutionAlias: null
      });
    }
  };

  componentDidMount(){
    this.props.setAnimatingOut({
      id: this.props.id,
      animatingOut: true
    });
  }

  render() {
    return (
      <div
        className="controls"
        style={{ display: this.props.controlsVisible ? null : "none" }}
      >
        <div className="volume-control">
          <div className="volume-indicator">
            <span
              className="volume-value"
              tabIndex={0}
              onKeyDown={e => {
                if (e.keyCode === 13 || e.keyCode === 32)
                  this.showVolumeModal(e);
              }}
              aria-label={this.props.t("Volume settings. {{volume}} microliters. Select to change the volume.", {volume: this.props.volume})}
              onClick={(e)=>{
                this.showVolumeModal(e);
              }}
            >
              {this.props.volume}{this.props.t("μl")}
            </span>
            <IconPointer style={{ color: colors.navy2, height: "44px" }} />
          </div>
        </div>
        <div
          className="plunger-control"
          style={{
            display:
              this.props.target !== null &&
              (this.props.target.type === "Solution" ||
                this.props.target.type === "BlottingPaper")
                ? null
                : "none"
          }}
          aria-label={this.props.t("Plunger setting. Current plunger position release. Hold down the mouse button to manipulate the plunger position.")}
        >
          <div
            tabIndex={0}
            className="plunger-indicator"
            onKeyDown={e => {
              if (e.keyCode === 13 || e.keyCode === 32) this.shiftPlunger(e);
            }}
            onKeyUp={e => {
              if (e.keyCode === 13 || e.keyCode === 32) this.shiftPlunger(e);
            }}
            onBlur={this.shiftPlunger}
            onMouseDown={this.shiftPlunger}
            onMouseOut={this.shiftPlunger}
            onDragStart={this.shiftPlunger}
            onMouseUp={this.shiftPlunger}
          >
            <div className="plunger-value-background">
              <span aria-label={this.props.t("Plunger position,")+" "+this.props.t(this.props.plungerPosition)} className="plunger-value">{this.props.t(this.props.plungerPosition)}</span>
            </div>
            <div className="plunger-graphics" aria-hidden="true">
              <Graphics id={this.props.id} tabIndex="-1"/>
            </div>
          </div>
        </div>
        <div className="move-menu" style={{bottom: this.props.target !== null &&
        (this.props.target.type === "Solution" ||
          this.props.target.type === "BlottingPaper")?"calc(100% + 148px)":null}}>
          <button
            tabIndex={0}
            className="move-button"
            aria-label={this.props.t("Move menu. Select to view the available positions.")}
            onClick={this.showMoveMenu}
          >
            <img src={WhiteHamburgerIcon} alt=""/>
          </button>
        </div>
        <div
          className="eject-btn-container"
          style={{
            display:
              this.props.target !== null && this.props.target.type === "Trash" && this.props.tipAttached
                ? null
                : "none"
          }}
        >
          <button className="eject-btn" aria-label={this.props.t("Eject tip. Select to remove the tip from your micropipette.")} onClick={this.ejectTip}>
            {/*<img src={Eject} aria-hidden="true" aria-label={this.props.t("Eject button")} />*/}
            <span
              className="eject-value"
              tabIndex={0}
              aria-label={this.props.t("Eject button")}
            >
              {this.props.t("Eject tip")}
            </span>
            <IconPointer
              style={{ color: colors.blue1, height: "44px" }} 
              alt="" aria-hidden="true" role="img"
            />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,
    target: state.scene.lastDrop.lastTarget,
    type: state.pipette.pipettes[ownProps.id - 1].type,
    volume: state.pipette.pipettes[ownProps.id - 1].volume,
    solution: state.pipette.pipettes[ownProps.id - 1].solution,
    fragments: state.pipette.pipettes[ownProps.id - 1].fragments,
    solutionAlias: state.pipette.pipettes[ownProps.id - 1].solutionAlias,
    controlsVisible: state.pipette.pipettes[ownProps.id - 1].controlsVisible,
    tipAttached: state.pipette.pipettes[ownProps.id - 1].tipAttached,
    tipUsed: state.pipette.pipettes[ownProps.id - 1].tipUsed,
    plungerPosition: state.pipette.pipettes[ownProps.id - 1].plungerPosition,
    animatingOut: state.pipette.pipettes[ownProps.id - 1].animatingOut,
    prevSolution: state.pipette.pipettes[ownProps.id - 1].prevSolution,
    currentPlungerPos:
      state.pipette.pipettes[ownProps.id - 1].currentPlungerPos,
    targetList: state.scene.targetList,
    heldObject: state.scene.heldObject,
    interactions: state.scene.interactions,
    moveMenuDisplay: state.moveMenu.display,

    interactionProps: {
      tipBoxes: state.tipBox.tipBoxes,
      gelBoxes: (Object.hasOwn(state, 'gelBox'))?state.gelBox.gelBoxes:null,
      solutions: state.solution.solutions,
      blotPapers: state.blotPaper.blotPapers,
      trashFull: state.trash.open,
      lastDrop: state.scene.lastDrop
    }
  };
};

export default connect(
  mapStateToProps,
  {
    pushInteractions,
    // incVol,
    // decVol,
    setPipetteSolution,
    setTipAttached,
    setTipUsed,
    setAnimatingOut,
    setPlungerPosition,
    setCurrentPlungerPos,
    depositBlotPaper,
    trashFull,
    incSolution,
    decSolution,
    setControlVisibility,
    setModal,
    showModal,
    setMoveMenu,
    showMoveMenu,
    setHeldObject,
    setHeld,
    setGelLane,
    setPipetteControlVisibility,
    makeGelImgConfig,
    // setVol,
    setSolutionMixed,

    toggleShowVolumeModal,
    toggleGelboxPipetteModal
  }
)(withTranslation()(Controls));
